module.exports = __webpack_public_path__ + "token_value_redeemed.b11ddbe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/analytics_icons/token_value_redeemed.png
// module id = 470
// module chunks = 0